// extracted by mini-css-extract-plugin
module.exports = {"wrap":"AccordionHeader_wrap__JxhnO","open":"AccordionHeader_open__1S4zT","trigger":"AccordionHeader_trigger__Syrf7"};